/**
 * Query Key factory for all clinic queries.
 *
 * @module Clinic
 */

export const clinicQKeys = {
  all: () => ["clinic"] as const,

  consultationServices: () =>
    [...clinicQKeys.all(), "consultationServices"] as const,

  consultationServicesWithFilters: (filters: {
    status?: string;
    category?: string;
  }) => [...clinicQKeys.consultationServices(), { ...filters }] as const,

  consultationServicesDetailed: () =>
    [...clinicQKeys.consultationServices(), "detailed"] as const,

  labs: () => [...clinicQKeys.all(), "labs"] as const,

  labsWithFilters: (filters: { category?: string }) =>
    [...clinicQKeys.labs(), { ...filters }] as const,

  laboratoryServices: () => [...clinicQKeys.all(), "laboratoryServices"] as const,

  laboratoryServicesDetailed: () =>
    [...clinicQKeys.laboratoryServices(), "detailed"] as const,

  collectionMethods: () => [...clinicQKeys.all(), "collectionMethods"] as const,

  collectionMethodsDetailed: () =>
    [...clinicQKeys.collectionMethods(), "detailed"] as const,

  radiologies: () => [...clinicQKeys.all(), "radiologies"] as const,

  treatmentPlans: () => [...clinicQKeys.all(), "treatmentPlans"] as const,

  consumables: () => [...clinicQKeys.all(), "consumables"] as const,

  files: () => [...clinicQKeys.all(), "files"] as const,

  filesWithFilters: (filters: {
    search?: string;
    doctorId?: string;
  }) => [...clinicQKeys.files(), { ...filters }] as const,

  treatmentPlansDetailed: () =>
    [...clinicQKeys.treatmentPlans(), "detailed"] as const,

  partners: () => [...clinicQKeys.all(), "partners"] as const,

  partnersWithFilters: (filters: {
    pagination?: { page?: number; pageSize?: number };
    search?: string;
    isActive?: boolean;
    isOrganization?: boolean;
  }) => [...clinicQKeys.partners(), { ...filters }] as const,
};
